// @ts-nocheck
import React, { createContext, useContext } from 'react';
import { useSalespeople } from '@/hooks/query/salespeople';

const SalesPeopleContext = createContext();

/**
 * currencies provider.
 */
function SalesPeopleProvider({ ...props }) {
  // fetches the currencies list.
  const { data: salespoeple, isLoading: isSalespoepleLoading } = useSalespeople();

  const state = {
    salespoeple,
    isSalespoepleLoading,
  };

  return <SalesPeopleContext.Provider value={state} {...props} />;
}

const useSalesPeopleContext = () => useContext(SalesPeopleContext);

export { SalesPeopleProvider, useSalesPeopleContext };
